export default __webpack_public_path__ + "static/media/ring_tone.c842af3f.wav";